// IIFE - Immediately Invoked Function Expression
(function($, window, document) {

    // The $ is now locally scoped 

    // Listen for the jQuery ready event on the document
    $(function() {

        // The DOM is ready!

    });

    gsap.registerPlugin(ScrollTrigger);

    const counter = document.querySelectorAll('.count');
    if (counter) {
      counter.forEach(el => {
        const end = parseFloat(el.dataset.end) || 0;
        const proxy = { val: 0 };

        gsap.to(proxy, {
          val: end,
          duration: 2,
          ease: "power2.out",
          onUpdate: () => {
            el.textContent = Math.round(proxy.val).toLocaleString('pt-BR');
          },
          scrollTrigger: {
            trigger: el,
            start: "top 90%",   // quando o elemento chegar a 80% da viewport
            /*toggleActions: "play none none none", */
            toggleActions: "play none none reverse",
            //once: true          // roda só uma vez
          }
        });
      });     
    }


    const typingEl = document.querySelectorAll(".-typing");
    if (typingEl.length > 0) {
      gsap.utils.toArray(".-typing").forEach((text) => {
        //let text = document.querySelector(".-typing");
        let content = text.textContent;
        text.textContent = ""; // clear first
        gsap.to(text, {
          duration: 2.5,
          text: content,  // Requires TextPlugin
          ease: "none"
        });
      });
    }
    // Fade-in sections on scroll
    gsap.utils.toArray(".-fade-in").forEach((secfade) => {
      gsap.from(secfade, {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: secfade,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });
    });

    gsap.utils.toArray(".-animate-in").forEach((sec) => {
      /*gsap.to(sec, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "none",
        //ease: "power2.out",
        scrollTrigger: {
          trigger: sec,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });*/
      gsap.from(sec, {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: sec,
          start: "top 80%",
          toggleActions: "play none none "
        }
      });
    });

    const slides = document.querySelectorAll('.-hg-main-slide');
    let currentIndex = 0;
    const slideInterval = 5000; // 5 seconds per slide

    function nextSlide() {
      // Remove active class from the current slide
      slides[currentIndex].classList.remove('active');
      
      // Calculate the next index (looping back to 0 at the end)
      currentIndex = (currentIndex + 1) % slides.length;
      
      // Add active class to the new slide
      slides[currentIndex].classList.add('active');
    }

    // Start the auto-timer
    setInterval(nextSlide, slideInterval);    
    
    //Menu trigger
    var menuTrigger = document.getElementsByClassName("menu-trigger-btn"),
        menu = document.getElementById("main-nav");
    
    var toggleMenu = function() {
    	   //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("menu-active");
    };

    for (var i = 0; i < menuTrigger.length; i++) {
        menuTrigger[i].addEventListener('click', toggleMenu, false);
    }

    //Search trigger
    var searchTrigger = document.getElementsByClassName("search-trigger-btn");
    
    var toggleSearch = function() {
         //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("search-active");
    };

    for (var i = 0; i < searchTrigger.length; i++) {
        searchTrigger[i].addEventListener('click', toggleSearch, false);
    }

    //modal trigger
    var modalTrigger = document.getElementsByClassName("modal-trigger-btn");
    
    var toggleModal = function() {
        event.preventDefault();
        const modal = this.dataset.modal;
        if (modal) {
          document.getElementById(modal).classList.add('-modal-active');
        }
         //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("modal-active");
    };

    for (var i = 0; i < modalTrigger.length; i++) {
        modalTrigger[i].addEventListener('click', toggleModal, false);
    }

    //modal close
    var modalClose = document.getElementsByClassName("modal-close-btn");
    
    var closeModal = function() {
        event.preventDefault();
        const modals = document.querySelectorAll('.-modal');
        modals.forEach(element => {
          element.classList.remove('-modal-active');
        });
        const formModals = document.querySelectorAll('.-modal-form');
        formModals.forEach(element => {
          element.classList.remove('-active');
        });
        document.body.classList.remove("modal-active");
    };

    for (var i = 0; i < modalClose.length; i++) {
        modalClose[i].addEventListener('click', closeModal, false);
    }     
    
    

    function redirect(goto){
        /*var conf = confirm("Are you sure you want to go elswhere?");
        if (conf && goto != '') {
            window.location = goto;
        }*/
        window.location = goto;
    }
   
    /*Anchor scroll*/
    const anchors = document.querySelectorAll(".scroll-anchor");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
     
    function clickHandler(e) {
      e.preventDefault();
      const header = document.querySelector("header").offsetHeight;
      const href = this.getAttribute("href"); 
      const offsetTop = document.querySelector(href).offsetTop;
     
      scroll({
        //top: offsetTop-header,
        top: offsetTop,
        behavior: "smooth"
      });
    }

    /*Anchor scroll nav*/
    const anchorsNav = document.querySelectorAll(".scroller > a");
     
    for (const anchorNav of anchorsNav) {
      anchorNav.addEventListener("click", clickHandlerNav);
    }
     
    function clickHandlerNav(e) {
      e.preventDefault();
      let header = document.querySelector("header").offsetHeight;
      let href = this.getAttribute("href"); 
      let split = href.split('#');
      let anchor = '#'+split[1];
      let offsetTop = document.querySelector(anchor).offsetTop;
      if (document.querySelector("header").classList.contains('-sticky')) {
        
      }else{
        header = header-20;
      }
      
      document.body.classList.remove("menu-active");
      
     
      scroll({
        top: offsetTop-header,
        /*top: offsetTop,*/
        behavior: "smooth"
      });
    } 


    /*Accordion*/
    $('[data-accordion]').click(function(e) {
        e.preventDefault();
        var parent = $(this).closest('.-accordion');
        /*var elParent = $(this).closest('.-accordion-item');*/

        //parent.find('.-accordion-item').removeClass('-active');

        if ( $(this).closest('.-accordion-item').hasClass('-active') ) {
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').removeClass('-active');
        }else{
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').addClass('-active');
        }
        
    });         
      

    /*Dropdown mobile*/
    $('.dropdown-toggle-hover').click(function(){
      
      if ($(window).width() < 1025) {
        event.preventDefault();
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }else{
        return;
      }
    });


    /*Tiny slider services*/
    const tnsSliderGrid = document.querySelectorAll('.-services-tns');
    tnsSliderGrid.forEach(SliderGrid => {
      const tnsSliderGrid = tns({
          rewind: true,
          container: SliderGrid,
          items: 3,
          nav: false,
          controls: true,
          autoplayButtonOutput: false,
          autoplayHoverPause: true,
          autoplay: false,
          autoplayTimeout: 3000,
          gutter: 24,
          loop: false,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:chevron-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:chevron-right"></iconify-icon></span>'],
          responsive: { 
              1920: {
                items: 2,
                //autoplay: true,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              1366: {
                items: 2.8,
                //autoplay: true,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 3,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1,
                //autoplay: true,
                //nav: true,
                //gutter: 0
                /*loop: true,
                */
                /*gutter: 0,*/
              }, 
          } 
      });
      // Reference the bar
      const progressBar = document.getElementById('progress-bar');

      // Function to update the bar
      function updateProgressBar(info) {
        // Total items (5) minus items shown (3) + 1 = The last possible "step" (3)
        const maxStep = info.slideCount - info.items + 1;

        // Calculate percentage based on the current step relative to the max step
        // We use Math.min to ensure it never exceeds 100%
        const percentage = Math.min((info.displayIndex / maxStep) * 100, 100);

        progressBar.style.width = percentage + "%";
      }

      // 1. Run once on initialization
      updateProgressBar(tnsSliderGrid.getInfo());

      // 2. Listen for every slide change
      tnsSliderGrid.events.on('indexChanged', function(info) {
        updateProgressBar(info);
      });
    });    

    /*Tiny slider testimonials*/
    const tnsSliderTestimonials = document.querySelectorAll('.-testimonials-tns');
    tnsSliderTestimonials.forEach(SliderTestimonials => {
      const tnsSliderTestimonials = tns({
          container: SliderTestimonials,
          items: 3,
          nav: false,
          controls: true,
          autoplayButtonOutput: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplayTimeout: 4000,
          gutter: 16,
          loop: true,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          responsive: { 
              1366: {
                items: 3,
                autoplay: true
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 3,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1,
                autoplay: true
                //nav: true,
                //gutter: 0
                /*loop: true,
                */
                /*gutter: 0,*/
              }, 
          } 
      });
    });    


    /*Tiny slider Events*/
    const tnsSliderEvents = document.querySelectorAll('.-events-tns');
    tnsSliderEvents.forEach(SliderEvents => {
      const tnsSliderEvents = tns({
          container: SliderEvents,
          items: 1,
          mode: 'gallery',
          animateIn: 'tns-fadeIn',
          animateOut: 'tns-fadeOut',
          speed: 1000,
          slideBy: 'page',
          nav: true,
          controls: false,
          navContainer: '#custom-events-bullets',
          navAsThumbnails: true,
          autoplayButtonOutput: false,
          autoplayHoverPause: true,
          autoplay: false,
          autoplayTimeout: 4000,
          gutter: 0,
          loop: true,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          responsive: { 
              1366: {
               /* //items: 1,
                autoplay: false,
                nav: true,
                controls: false,*/
                items: 1,
                autoplay: false,
                nav: true,
                controls: false,
              },
              768: {
                /*items: 1*/
              },
              320: {
                items: 1,
                autoplay: true,
                nav: false,
                controls: true,
              }, 
          } 
      });
    });

    

    /*Tiny slider sponsor*/
    const tnsSingle = document.querySelector('.-single-tns');
    if (tnsSingle) {
      const tnsSlider = tns({
        container: tnsSingle,
        autoheight: false,
        items: 1,
        /*mouseDrag: true,*/
        autoplayButtonOutput: false,
        autoplay: false,
        loop: true,
        swipeAngle: false,
        navContainer: '.-single-tns-thumbs',
        navAsThumbnails: true,
        controlsText: ['<span class="-prev"><span class="iconify" data-icon="iconoir:arrow-left"></span></span>', '<span class="-next"><span class="iconify" data-icon="iconoir:arrow-right"></span></span>'],
  
        /*responsive: {     
          320: {
          },
          768: {
          },
          900: {
          }
        }*/


      });
      //tnsSlider.updateSliderHeight(); 
      var customizedFunction = function (info, eventName) {
        //tnsSlider.updateSliderHeight();
        //console.log(info);
        var indexCurrent = info.displayIndex;
        console.log(indexCurrent);
        var nextHeight = info.slideItems[indexCurrent].childNodes[1].clientHeight;
        /*console.log(nextHeight)*/
        info.container.offsetParent.childNodes[2].setAttribute('style', 'height:'+ nextHeight + 'px;');
      }
      tnsSlider.events.on('transitionEnd', customizedFunction);
      /*tnsSlider.events.on('indexChanged', customizedFunction);*/
    
    }
    const tnsSingleThumbs = document.querySelector('.-single-tns-thumbs');
    if (tnsSingleThumbs) {
      const tnsSlider = tns({
        container: tnsSingleThumbs,
        items: 6,
        mouseDrag: true,
        nav: false,
        controls: false,
        autoplayButtonOutput: false,
        gutter: 10,
        autoplay: false,
        controlsPosition: "bottom",
        loop: true,
        autoHeight: true,
  
        /*responsive: {     
          320: {
          },
          768: {
          },
          900: {
          }
        }*/

      });   
    
    }


                 

     /*GDPR*/
    document.addEventListener('DOMContentLoaded', function() {
      var cookiebar = document.querySelector('.cookiebar');
      if (cookiebar) { 
          var closecookiebar = document.querySelector('.hide-cookiebar-target');
          var acceptcookie = document.querySelector('.accept-cookies');
          var refusecookie = document.querySelector('.refuse-cookies');
          var cookie = readCookie('wh_cookie_lgpd_consent');/*Name of cookie*/
          //console.log(cookie);

          if (cookie == "true") {
              cookiebar.style.display = "none";
          }else if (cookie == "false") {
              cookiebar.style.display = "none";
          }else{
              cookiebar.classList.add("no-cookie-yet");
          }

          acceptcookie.addEventListener('click', function(e) {
              if(cookie != "true") {
                cookiebar.style.display = "none";
                createCookie('wh_cookie_lgpd_consent', "true", 7);
              } 
              e.preventDefault();
          });

          if (refusecookie) {
            refusecookie.addEventListener('click', function(e) {
                if(cookie != "true") {
                  cookiebar.style.display = "none";
                  createCookie('wh_cookie_lgpd_consent', "false", 7);
                }
                e.preventDefault();
            });  
          }
          
          if (closecookiebar) {
            closecookiebar.addEventListener('click', function(e) {
                cookiebar.style.display = "none";
                /*if(cookie != "true") {
                  createCookie('wh_cookie_lgpd_consent', "true", 1);
                } */
                e.preventDefault();
            });
          }

      }

      function createCookie(name, value, days) {
          if(days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
          } else var expires = "";
          document.cookie = name + "=" + value + expires + "; path=/"
      }

      function readCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
           
          }
          return null;
      }

      function eraseCookie(name) {
          createCookie(name, "", -1);
      }

    });

    /*Scroller slider*/
    const iScrollers = document.querySelectorAll(".i-scroll");

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      addAnimation();
    }

    function addAnimation() {
      iScrollers.forEach((iScroller) => {
        iScroller.setAttribute("data-animated", true);

        const iScrollerInner = iScroller.querySelector(".i-scroll__inner");
        const iScrollerContent = Array.from(iScrollerInner.children);

        iScrollerContent.forEach((item) => {
          const duplicatedItem = item.cloneNode(true);
          duplicatedItem.setAttribute("aria-hidden", true);
          iScrollerInner.appendChild(duplicatedItem);
        });
      });
    }          

    (function() {
      const wrap = document.querySelector('.hero-video-wrap');
      const playBtn = document.querySelector('.hero-video-play');
      const youtubeVideo = document.getElementById('heroVideoYoutube');
      const video = document.getElementById('heroVideo');
      let player;
      let isPlayerReady = false; // Flag para evitar o erro

      if (youtubeVideo) {
        // 1. Carrega a API do YouTube
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // 2. Inicializa o Player
        window.onYouTubeIframeAPIReady = function() {
          player = new YT.Player('heroVideoYoutube', {
            videoId: 'R73nl9vDVk0',
            playerVars: {
              'autoplay': 0,
              'mute': 1,
              'controls': 0,
              'rel': 0,
              'showinfo': 0,
              'modestbranding': 1
            },
            events: {
              'onReady': () => { isPlayerReady = true; }, // Ativa a flag quando estiver pronto
              'onStateChange': onPlayerStateChange
            }
          });
        };

        // 3. Clique do Botão (Com proteção contra o erro)
        playBtn.addEventListener('click', () => {
          // Só executa se o player existir E os métodos estiverem disponíveis
          if (player && isPlayerReady && typeof player.getPlayerState === 'function') {
            const state = player.getPlayerState();

            if (state !== YT.PlayerState.PLAYING) {
              player.playVideo();
              player.unMute();
              wrap.classList.add('is-playing');
            } else {
              player.pauseVideo();
              wrap.classList.remove('is-playing');
            }
          } else {
            console.log("O player ainda está carregando...");
          }
        });

        function onPlayerStateChange(event) {
          if (event.data === YT.PlayerState.ENDED) {
            wrap.classList.remove('is-playing');
            player.seekTo(0);
            player.pauseVideo(); 
          }
        }
      }else{
        // Start muted to allow autoplay on some devices after first tap
        video.muted = true;

        playBtn.addEventListener('click', async () => {
          if (video.paused) {
            await video.play();
            wrap.classList.add('is-playing');
            video.muted = false;
          } else {
            video.pause();
            wrap.classList.remove('is-playing');
            video.muted = true;
          }
        });

        // If the video ends and you want it to loop:
        video.addEventListener('ended', () => {
          video.currentTime = 0;
          wrap.classList.remove('is-playing');
          /*video.play();*/
        });
      }
    })();                

    var header = document.querySelectorAll(".dynamic-header");
    if (!header.length) { return; }
    var headerHeight = header[0].offsetHeight;
    window.onscroll = function() {
      //console.log(window.innerWidth)
        var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        var vh1o3 = (window.innerWidth/3);
        var vh1o2 = (window.innerWidth/2);
        var vhMin = 100;
        var vhMinWA = 200;
        /*if (scrollPosition > headerHeight && window.innerWidth > 992) {*/
        /*if (scrollPosition > headerHeight) {*/
        if (scrollPosition > vhMin) {
                header[0].classList.add('-sticky');
                
        }else{
                header[0].classList.remove('-sticky');
                
        }

        if (scrollPosition > vhMinWA) {
                
                document.body.classList.add("-has-sticky");
        }else{
                
                document.body.classList.remove("-has-sticky");
        }
    }; 

   

}(window.jQuery, window, document));